module.exports = __webpack_public_path__ + "media/images/bg/mosaic/ab1-8fe2c34999aa686d726fb46e7357a96b.jpg";